(function () {
  const additions = [
  {
    "id": "bc6413",
    "category": "tshirts",
    "audience": "womens",
    "code": "BC6413",
    "label": "Bella Canvas Relaxed Triblend Tee",
    "handle": "bella-canvas-bc6413-women-s-relaxed-triblend-tee",
    "title": "Bella Canvas BC6413 – Women's Relaxed Triblend Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc6413-women-s-relaxed-triblend-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC6413.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-solid-black-triblend.jpg?v=1792605845",
    "colours": [
      {
        "name": "Charcoal-Black Triblend",
        "hex": "#363432",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-charcoal-black-triblend.jpg?v=1792605830",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Grey Triblend",
        "hex": "#7C7F74",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-grey-triblend.jpg?v=1792605834",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Oatmeal Triblend",
        "hex": "#4A4F43",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-oatmeal-triblend.jpg?v=1792605838",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Olive Triblend",
        "hex": "#7E6F4A",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-olive-triblend.jpg?v=1792605842",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Black Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-solid-black-triblend.jpg?v=1792605845",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid White Triblend",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6413-solid-white-triblend.jpg?v=1792605849",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "S": 5016,
      "M": 5016,
      "L": 5016,
      "XL": 5016,
      "2XL": 5676,
      "3XL": 6336
    },
    "pricePending": false,
    "description": "A soft women’s crewneck tee with a relaxed fit and lightweight triblend fabric, ready for custom decoration.",
    "details": [
      "6.3 oz/ly (CA), 3.8 oz/sq yd (US) 128.8 gsm (EU)",
      "50/25/25 polyester/Airlume combed and ring spun cotton/rayon",
      "40 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Relaxed Fit",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc6400cvc",
    "category": "tshirts",
    "audience": "womens",
    "code": "BC6400CVC",
    "label": "Bella Canvas Relaxed Heather CVC Short Sleeve Tee",
    "handle": "bella-canvas-bc6400cvc-women-s-relaxed-heather-cvc-short-sleeve-tee",
    "title": "Bella Canvas BC6400CVC – Women's Relaxed Heather CVC Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc6400cvc-women-s-relaxed-heather-cvc-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC6400CVC.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-black-heather.jpg?v=1792605860",
    "colours": [
      {
        "name": "Black Heather",
        "hex": "#363432",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-black-heather.jpg?v=1792605860",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Dark Grey Heather",
        "hex": "#505656",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-dark-grey-heather.jpg?v=1792605864",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Deep Teal",
        "hex": "#18453B",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-heather-deep-teal.jpg?v=1792605868",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Mauve",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-heather-mauve.jpg?v=1792605872",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-heather-navy.jpg?v=1792605875",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Slate",
        "hex": "#254A5D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-heather-slate.jpg?v=1792605880",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Black Blend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-solid-black-blend.jpg?v=1792605884",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid White Blend",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400cvc-solid-white-blend.jpg?v=1792605893",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "S": 4620,
      "M": 4620,
      "L": 4620,
      "XL": 4620,
      "2XL": 5280,
      "3XL": 5940
    },
    "pricePending": false,
    "description": "A relaxed women’s crewneck tee in soft heather CVC fabric, with a smooth surface for custom designs.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "52/48 Airlume combed and ring spun cotton/polyester",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Relaxed fit",
      "Black Heather: 90% Airlume cotton / 10% polyester.",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc6400",
    "category": "tshirts",
    "audience": "womens",
    "code": "BC6400",
    "label": "Bella Canvas Relaxed Jersey Short Sleeve Tee",
    "handle": "bella-canvas-bc6400-women-s-relaxed-jersey-short-sleeve-tee",
    "title": "Bella Canvas BC6400 – Women's Relaxed Jersey Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc6400-women-s-relaxed-jersey-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC6400.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-black.jpg?v=1792605902",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-black.jpg?v=1792605902",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Military Green",
        "hex": "#445A3E",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-military-green.jpg?v=1792605906",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Natural",
        "hex": "#D6C39A",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-natural.jpg?v=1792605910",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-navy.jpg?v=1792605915",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Red",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-red.jpg?v=1792605919",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Vintage White",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-vintage-white.jpg?v=1792605923",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6400-white.jpg?v=1792605926",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 4224,
      "S": 4224,
      "M": 4224,
      "L": 4224,
      "XL": 4224,
      "2XL": 4884,
      "3XL": 5544
    },
    "pricePending": false,
    "description": "A relaxed women’s jersey tee made from Airlume cotton, with a classic crewneck and short sleeves.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Relaxed fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc6008",
    "category": "tshirts",
    "audience": "womens",
    "code": "BC6008",
    "label": "Bella Canvas Jersey Racerback Tank",
    "handle": "bella-canvas-bc6008-women-s-jersey-racerback-tank",
    "title": "Bella Canvas BC6008 – Women's Jersey Racerback Tank",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc6008-women-s-jersey-racerback-tank",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC6008.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6008-black.jpg?v=1792605936",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6008-black.jpg?v=1792605936",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6008-navy.jpg?v=1792605951",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      },
      {
        "name": "Teal",
        "hex": "#00BFB3",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6008-teal.jpg?v=1792605955",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc6008-white.jpg?v=1792605959",
        "sizes": [
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      }
    ],
    "prices": {
      "S": 4224,
      "M": 4224,
      "L": 4224,
      "XL": 4224,
      "2XL": 4884
    },
    "pricePending": false,
    "description": "A relaxed women’s racerback tank in soft Airlume cotton jersey, ready for custom designs and warm-weather layering.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Tear away label",
      "Side seamed",
      "Relaxed Fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3901",
    "category": "sweatshirts",
    "audience": "adult",
    "code": "BC3901",
    "label": "Bella Canvas Sponge Fleece Raglan Sweatshirt",
    "handle": "bella-canvas-bc3901-unisex-sponge-fleece-raglan-sweatshirt",
    "title": "Bella Canvas BC3901 – Unisex Sponge Fleece Raglan Sweatshirt",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3901-unisex-sponge-fleece-raglan-sweatshirt",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3901.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-black.jpg?v=1792605050",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-black.jpg?v=1792605050",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Dark Grey Heather",
        "hex": "#505656",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-dark-grey-heather.jpg?v=1792605966",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Forest",
        "hex": "#43635D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-heather-forest.jpg?v=1792605973",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-heather-navy.jpg?v=1792605977",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3901-navy.jpg?v=1792605981",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 7920,
      "S": 7920,
      "M": 7920,
      "L": 7920,
      "XL": 7920,
      "2XL": 8580,
      "3XL": 9240
    },
    "pricePending": false,
    "description": "A soft sponge fleece crewneck with raglan sleeves, made for everyday comfort and layering.",
    "details": [
      "13.3 oz/ly (CA), 8.0 oz/sq yd (US) 271.28 gsm (EU)",
      "52/48 Airlume combed and ring spun cotton/polyester fleece",
      "32 singles",
      "Tear away label",
      "Raglan sleeves",
      "Shoulder taping",
      "Side seamed",
      "Ribbed neck, cuffs and waistband",
      "Retail fit",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3739",
    "category": "hoodies",
    "audience": "adult",
    "code": "BC3739",
    "label": "Bella Canvas Sponge Fleece Full-Zip Hoodie",
    "handle": "bella-canvas-bc3739-unisex-sponge-fleece-full-zip-hoodie",
    "title": "Bella Canvas BC3739 – Unisex Sponge Fleece Full-Zip Hoodie",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3739-unisex-sponge-fleece-full-zip-hoodie",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3739.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-black.jpg?v=1792605992",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-black.jpg?v=1792605992",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Dark Grey Heather",
        "hex": "#505656",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-dark-grey-heather.jpg?v=1792605996",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Forest",
        "hex": "#43635D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-heather-forest.jpg?v=1792606000",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-heather-navy.jpg?v=1792606003",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3739-navy.jpg?v=1792606007",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 10560,
      "S": 10560,
      "M": 10560,
      "L": 10560,
      "XL": 10560,
      "2XL": 11220,
      "3XL": 11880
    },
    "pricePending": false,
    "description": "A sponge fleece zip hoodie with a metal zipper, white drawcords and front pockets for comfortable layering.",
    "details": [
      "13.3 oz/ly (CA), 8 oz/sq yd (US), 271.28 gsm (EU)",
      "52/48 Airlume combed and ring spun cotton/polyester fleece",
      "32 singles",
      "Tear away label",
      "White drawcords and zipper tape",
      "YKK® metal zipper",
      "Shoulder taping",
      "Side seamed",
      "Front pouch pockets",
      "Ribbed cuffs and waistband",
      "Retail fit",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "placement": "Front left chest print",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3719",
    "category": "hoodies",
    "audience": "adult",
    "code": "BC3719",
    "label": "Bella Canvas Sponge Fleece Pullover Hoodie",
    "handle": "bella-canvas-bc3719-unisex-sponge-fleece-pullover-hoodie",
    "title": "Bella Canvas BC3719 – Unisex Sponge Fleece Pullover Hoodie",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3719-unisex-sponge-fleece-pullover-hoodie",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3719.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-black.jpg?v=1792606017",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-black.jpg?v=1792606017",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Dark Grey Heather",
        "hex": "#505656",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-dark-grey-heather.jpg?v=1792606021",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Forest",
        "hex": "#43635D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-heather-forest.jpg?v=1792606025",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Heather Deep Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-heather-deep-teal.jpg?v=1792606029",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3719-navy.jpg?v=1792606033",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 9900,
      "S": 9900,
      "M": 9900,
      "L": 9900,
      "XL": 9900,
      "2XL": 10560,
      "3XL": 11220
    },
    "pricePending": false,
    "description": "A sponge fleece pullover hoodie with white drawcords and a roomy pouch pocket.",
    "details": [
      "13.3 oz/ly (CA), 8.0 oz/sq yd (US) 271.28 gsm (EU)",
      "52/48 Airlume combed and ring spun cotton/polyester fleece",
      "32 singles",
      "Tear away label",
      "White drawcords",
      "Shoulder taping",
      "Side seamed",
      "Pouch pocket",
      "Ribbed cuffs and waistband",
      "Retail fit",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3501",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3501",
    "label": "Bella Canvas Jersey Long Sleeve Tee",
    "handle": "bella-canvas-bc3501-unisex-jersey-long-sleeve-tee",
    "title": "Bella Canvas BC3501 – Unisex Jersey Long Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3501-unisex-jersey-long-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3501.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-black.jpg?v=1792606049",
    "colours": [
      {
        "name": "Asphalt",
        "hex": "#6C6864",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-asphalt.jpg?v=1792606045",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-black.jpg?v=1792606049",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Military Green",
        "hex": "#445A3E",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-military-green.jpg?v=1792606054",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Natural",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-natural.jpg?v=1792606058",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-navy.jpg?v=1792606062",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-teal.jpg?v=1792606066",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3501-white.jpg?v=1792606085",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "prices": {
      "XS": 5940,
      "S": 5940,
      "M": 5940,
      "L": 5940,
      "XL": 5940,
      "2XL": 6600,
      "3XL": 7260,
      "4XL": 7920
    },
    "pricePending": false,
    "description": "A soft cotton jersey long-sleeve tee with ribbed cuffs and a retail fit.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Rib knit neck and cuffs",
      "Retail fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl",
      "4XL": "4xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3480",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3480",
    "label": "Bella Canvas Jersey Tank",
    "handle": "bella-canvas-bc3480-unisex-jersey-tank",
    "title": "Bella Canvas BC3480 – Unisex Jersey Tank",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3480-unisex-jersey-tank",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3480.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-black.jpg?v=1792606101",
    "colours": [
      {
        "name": "Asphalt",
        "hex": "#6C6864",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-asphalt.jpg?v=1792606098",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      },
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-black.jpg?v=1792606101",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-navy.jpg?v=1792606107",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-teal.jpg?v=1792606111",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3480-white.jpg?v=1792606127",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 3960,
      "S": 3960,
      "M": 3960,
      "L": 3960,
      "XL": 3960,
      "2XL": 4620,
      "3XL": 5280
    },
    "pricePending": false,
    "description": "A cotton jersey tank with a rounded neckline and retail fit, ready for custom decoration.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Side seamed",
      "Retail fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3413",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3413",
    "label": "Bella Canvas Triblend Short Sleeve Tee",
    "handle": "bella-canvas-bc3413-unisex-triblend-short-sleeve-tee",
    "title": "Bella Canvas BC3413 – Unisex Triblend Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3413-unisex-triblend-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3413.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-black-triblend.jpg?v=1792606177",
    "colours": [
      {
        "name": "Athletic Grey Triblend",
        "hex": "#898D8D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-athletic-grey-triblend.jpg?v=1792606138",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Black Heather Triblend",
        "hex": "#363432",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-black-heather-triblend.jpg?v=1792606142",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Charcoal-Black Triblend",
        "hex": "#363432",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-charcoal-black-triblend.jpg?v=1792606145",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Emerald Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-emerald-triblend.jpg?v=1792606149",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Grey Triblend",
        "hex": "#7C7F74",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-grey-triblend.jpg?v=1792606154",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Maroon Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-maroon-triblend.jpg?v=1792606156",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Mauve Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-mauve-triblend.jpg?v=1792606160",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Military Green Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-military-green-triblend.jpg?v=1792606162",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-navy-triblend.jpg?v=1792606166",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Oatmeal Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-oatmeal-triblend.jpg?v=1792606169",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Olive Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-olive-triblend.jpg?v=1792606172",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Black Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-black-triblend.jpg?v=1792606177",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Dark Grey Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-dark-grey-triblend.jpg?v=1792606180",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Forest Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-forest-triblend.jpg?v=1792606184",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Navy Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-navy-triblend.jpg?v=1792606188",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid Red Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-red-triblend.jpg?v=1792606190",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Solid White Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-solid-white-triblend.jpg?v=1792606193",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Steel Blue Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-steel-blue-triblend.jpg?v=1792606197",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Tan Triblend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-tan-triblend.jpg?v=1792606201",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "True Royal Triblend",
        "hex": "#0033A0",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3413-true-royal-triblend.jpg?v=1792606205",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 4620,
      "S": 4620,
      "M": 4620,
      "L": 4620,
      "XL": 4620,
      "2XL": 5280,
      "3XL": 5940,
      "4XL": 6600
    },
    "pricePending": false,
    "description": "A lightweight unisex triblend tee with a soft feel, crew neckline and retail fit.",
    "details": [
      "6.3 oz/ly (CA), 3.8 oz/sq yd (US) 128.8 gsm (EU)",
      "50/25/25 polyester/Airlume combed and ring spun cotton/rayon",
      "40 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Retail Fit",
      "Black Heather Triblend: 70% cotton / 15% polyester / 15% rayon.",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl",
      "4XL": "4xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3010",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3010",
    "label": "Bella Canvas 6 Oz Heavyweight Tee",
    "handle": "bella-canvas-bc3010-unisex-6-oz-heavyweight-tee",
    "title": "Bella Canvas BC3010 – Unisex 6 Oz Heavyweight Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3010-unisex-6-oz-heavyweight-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3010.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-black.jpg?v=1792606213",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-black.jpg?v=1792606213",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Forest",
        "hex": "#183029",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-forest.jpg?v=1792606217",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Natural",
        "hex": "#D6C39A",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-natural.jpg?v=1792606222",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-navy.jpg?v=1792606226",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Vintage Black",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-vintage-black.jpg?v=1792606229",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Vintage Brown",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-vintage-brown.jpg?v=1792606232",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "Vintage White",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-vintage-white.jpg?v=1792606236",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3010-white.jpg?v=1792606241",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL"
        ]
      }
    ],
    "prices": {
      "XS": 4620,
      "S": 4620,
      "M": 4620,
      "L": 4620,
      "XL": 4620,
      "2XL": 5280,
      "3XL": 5940
    },
    "pricePending": false,
    "description": "A heavyweight cotton tee with dropped shoulders and a relaxed, boxy silhouette.",
    "details": [
      "10 oz/ly (CA), 6 oz/sq yd (US) 203.46 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "20 singles",
      "Drop shoulder",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Boxy, relaxed fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3001y",
    "category": "tshirts",
    "audience": "youth",
    "code": "BC3001Y",
    "label": "Bella Canvas Jersey Short Sleeve Tee",
    "handle": "bella-canvas-bc3001y-youth-jersey-short-sleeve-tee",
    "title": "Bella Canvas BC3001Y – Youth Jersey Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3001y-youth-jersey-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3001Y.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-black.jpg?v=1792606249",
    "colours": [
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-black.jpg?v=1792606249",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "Natural",
        "hex": "#D6C39A",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-natural.jpg?v=1792606253",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "Navy",
        "hex": "#1B1C2D",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-navy.jpg?v=1792606257",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "Pink",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-pink.jpg?v=1792606260",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "Red",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-red.jpg?v=1792606264",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-teal.jpg?v=1792606268",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001y-white.jpg?v=1792606271",
        "sizes": [
          "S",
          "M",
          "L",
          "XL"
        ]
      }
    ],
    "prices": {
      "S": 3696,
      "M": 3696,
      "L": 3696,
      "XL": 3696
    },
    "pricePending": false,
    "description": "A soft cotton jersey crewneck tee sized for youth, with a classic fit and tear-away label.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Classic fit"
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3001cvc",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3001CVC",
    "label": "Bella Canvas Heather CVC Short Sleeve Tee",
    "handle": "bella-canvas-bc3001cvc-unisex-heather-cvc-short-sleeve-tee",
    "title": "Bella Canvas BC3001CVC – Unisex Heather CVC Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3001cvc-unisex-heather-cvc-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3001CVC.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-athletic-heather.jpg?v=1792606281",
    "colours": [
      {
        "name": "Athletic Heather",
        "hex": "#ADADAC",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-athletic-heather.jpg?v=1792606281",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Black Heather",
        "hex": "#363432",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-black-heather.jpg?v=1792606285",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Dark Grey Heather",
        "hex": "#505656",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-dark-grey-heather.jpg?v=1792606290",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Deep Heather",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-deep-heather.jpg?v=1792606294",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Heather Brown",
        "hex": "#5D4B3C",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-brown.jpg?v=1792606298",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Cardinal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-cardinal.jpg?v=1792606302",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Forest",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-forest.jpg?v=1792606305",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Mauve",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-mauve.jpg?v=1792606309",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-navy.jpg?v=1792606312",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Heather Olive",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-olive.jpg?v=1792606316",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Red",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-red.jpg?v=1792606320",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Sage",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-sage.jpg?v=1792606324",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Slate",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-slate.jpg?v=1792606327",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Tan",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-tan.jpg?v=1792606330",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Blue Lagoon",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-blue-lagoon.jpg?v=1792606334",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Columbia Blue",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-columbia-blue.jpg?v=1792606338",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Deep Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-deep-teal.jpg?v=1792606342",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Dusty Blue",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-dusty-blue.jpg?v=1792606346",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Grass Green",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-grass-green.jpg?v=1792606350",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Maroon",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-maroon.jpg?v=1792606353",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Midnight Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-midnight-navy.jpg?v=1792606355",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather Military Green",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-military-green.jpg?v=1792606359",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Heather True Royal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-heather-true-royal.jpg?v=1792606363",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Solid Black Blend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-solid-black-blend.jpg?v=1792606367",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Solid Navy Blend",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-solid-navy-blend.jpg?v=1792606371",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Solid White Blend",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001cvc-solid-white-blend.jpg?v=1792606375",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "prices": {
      "XS": 4224,
      "S": 4224,
      "M": 4224,
      "L": 4224,
      "XL": 4224,
      "2XL": 4884,
      "3XL": 5544,
      "4XL": 6204,
      "5XL": 6864
    },
    "pricePending": false,
    "description": "A soft unisex heather CVC tee with a crew neckline and retail fit, ready for custom designs.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "52/48 Airlume combed and ring spun cotton/polyester",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Retail fit",
      "Athletic Heather and Black Heather: 90% Airlume cotton / 10% polyester.",
      "Use care when applying heat to this blend during decoration or curing."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl",
      "4XL": "4xl",
      "5XL": "5xl"
    },
    "wholesaleDiscountPercentage": 50
  },
  {
    "id": "bc3001",
    "category": "tshirts",
    "audience": "adult",
    "code": "BC3001",
    "label": "Bella Canvas Jersey Short Sleeve Tee",
    "handle": "bella-canvas-bc3001-unisex-jersey-short-sleeve-tee",
    "title": "Bella Canvas BC3001 – Unisex Jersey Short Sleeve Tee",
    "productUrl": "https://strongnfreecdn.com/products/bella-canvas-bc3001-unisex-jersey-short-sleeve-tee",
    "supplierPdf": "https://media.sanmarcanada.com/pdfs/BC3001.pdf",
    "heroImage": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-black.jpg?v=1792606392",
    "colours": [
      {
        "name": "Ash",
        "hex": "#C7CDD1",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-ash.jpg?v=1792606384",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Asphalt",
        "hex": "#6C6864",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-asphalt.jpg?v=1792606388",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Black",
        "hex": "#2D2926",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-black.jpg?v=1792606392",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Dark Grey",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-dark-grey.jpg?v=1792606396",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Deep Teal",
        "hex": "#005876",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-deep-teal.jpg?v=1792606398",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Forest",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-forest.jpg?v=1792606402",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Kelly",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-kelly.jpg?v=1792606406",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Maroon",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-maroon.jpg?v=1792606410",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Military Green",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-military-green.jpg?v=1792606414",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Natural",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-natural.jpg?v=1792606417",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Navy",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-navy.jpg?v=1792606420",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Pink",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-pink.jpg?v=1792606425",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Red",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-red.jpg?v=1792606429",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Sage",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-sage.jpg?v=1792606433",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Teal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-teal.jpg?v=1792606438",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Team Purple",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-team-purple.jpg?v=1792606442",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "True Royal",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-true-royal.jpg?v=1792606445",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      },
      {
        "name": "Vintage Black",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-vintage-black.jpg?v=1792606449",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "Vintage White",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-vintage-white.jpg?v=1792606452",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL"
        ]
      },
      {
        "name": "White",
        "hex": "#FFFFFF",
        "image": "https://cdn.shopify.com/s/files/1/0086/9793/7979/files/bella-canvas-bc3001-white.jpg?v=1792606456",
        "sizes": [
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      }
    ],
    "prices": {
      "XS": 3960,
      "S": 3960,
      "M": 3960,
      "L": 3960,
      "XL": 3960,
      "2XL": 4620,
      "3XL": 5280,
      "4XL": 5940,
      "5XL": 6600
    },
    "pricePending": false,
    "description": "A unisex Airlume cotton jersey tee with a classic crew neckline, short sleeves and retail fit.",
    "details": [
      "7 oz/ly (CA), 4.2 oz/sq yd (US), 142.42 gsm (EU)",
      "100% Airlume combed and ring spun cotton",
      "32 singles",
      "Tear away label",
      "Shoulder taping",
      "Side seamed",
      "Retail fit",
      "Ash: 99% Airlume cotton / 1% polyester."
    ],
    "availabilityNote": "Sizes vary by colour. See the supplier sizing guide for measurements.",
    "checkoutPending": false,
    "wholesalePricePending": false,
    "carrierHandle": "snf-bella-canvas-wholesale-price-carrier",
    "sizePriceTiers": {
      "XS": "regular",
      "S": "regular",
      "M": "regular",
      "L": "regular",
      "XL": "regular",
      "2XL": "2xl",
      "3XL": "3xl",
      "4XL": "4xl",
      "5XL": "5xl"
    },
    "wholesaleDiscountPercentage": 50
  }
];
  const priority = ['bc3001', 'bc3001cvc', 'bc3413', 'bc3010', 'bc3501', 'bc3480', 'bc6400', 'bc6400cvc', 'bc6413', 'bc6008', 'bc3001y', 'bc3901', 'bc3719', 'bc3739'];
  additions.sort((a, b) => priority.indexOf(a.id) - priority.indexOf(b.id));
  window.SNF_GARMENT_CATALOG = additions.concat((window.SNF_GARMENT_CATALOG || []).filter((style) => !additions.some((item) => item.id === style.id)));
})();

